export default __webpack_public_path__ + "images/eth_4c4c45.svg";